module.exports = __webpack_public_path__ + "static/media/address-book.f50c0cc7.svg";